import { XdrSearchController } from '../controller/XdrSearchController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { InputQueryConfig, SearchEvents } from '../types';
import { TimeRange, TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';
import { Target } from '@nirvana/shared/dtos/types/dashboards/common';

export class XdrSearchWebComponent extends BaseWebComponentElement {
  public controller: XdrSearchController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: XdrSearchController,
    });
  }

  public executeQuery(config: InputQueryConfig) {
    const event = new CustomEvent(SearchEvents.RUN_QUERY, {
      detail: {
        input: config?.input,
        updateInput: config?.updateInput,
      },
      bubbles: true,
      composed: true,
    });
    this.controller?.view.dom.$searchQueryPanel.dispatchEvent(event);
  }

  public async setDateFilterTimeFrame(timeFrame) {
    const timeRange: TimeRange = {
      kind: TimeRangeKind.ABSOLUTE_TIME_RANGE,
      absolute: {
        fromTimestamp: new Date(timeFrame.fromTimestamp).getTime(),
        toTimestamp: new Date(timeFrame.toTimestamp).getTime(),
      },
    };
    this.controller?.view.dom.$searchQueryPanel.datetimeFilter.setSelectedTimeRange(timeRange);
  }

  public async setCompanyFilter(company: Target) {
    //@ts-ignore
    this.controller?.setCompanyFilter(company);
  }
}
